export default "__VITE_PUBLIC_ASSET__fbdf8d10__"